import { LatLon } from '../domain/types.ts';
import { getApiUrl } from '../config/apiConfig.ts';

export const OFFLINE_QUOTES = [
  'Vỉa hè đông người qua lại, mở quầy lúc này là hốt bạc!',
  'Bà cụ bán nước chè đầu ngõ vừa dọn hàng, nhường lại góc đắc địa.',
  'Trời sắp đổ mưa, chuẩn bị bung bạt che chắn cho khách nhé sếp!',
  'Mấy cô cậu học sinh tan trường đang kéo nhau qua đường nườm nượp.',
  'Quán đối diện vừa tăng giá, khách đang đổ dồn sang quán mình!',
  'Trật tự đô thị vừa rẽ vào phố lớn, vỉa hè phố mình vẫn an toàn.',
  'Hương trà đào thoang thoảng làm nức lòng người đi bộ qua đường.',
  'Khách quen khen nước trà hôm nay đậm đà, danh tiếng quán tăng vọt!',
  'Đã chiếm lĩnh thêm một góc phố, danh tiếng Bá Chủ Vỉa Hè đang tới gần!',
  'Tiếng còi xe và nhịp sống phố phường tạo nên bản giao hưởng kinh doanh tuyệt vời.',
];

export class FallbackLore {
  public static getRandomQuote(): string {
    const idx = Math.floor(Math.random() * OFFLINE_QUOTES.length);
    return OFFLINE_QUOTES[idx]!;
  }
}

export class NarrativeClient {
  private cache: Map<string, { quote: string; expiresAt: number }> = new Map();

  public async getContextLore(
    action: string,
    neighborhoodName: string,
    _center: LatLon
  ): Promise<string> {
    const cacheKey = `${action}-${neighborhoodName}`;
    const cached = this.cache.get(cacheKey);

    if (cached && cached.expiresAt > Date.now()) {
      return cached.quote;
    }

    try {
      // Async call ra Worker Edge proxy (nếu có base URL)
      // Hard rule: Không block game loop, có timeout 3000ms
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 3000);

      // Thử gọi proxy Worker
      const res = await fetch(getApiUrl('/api/narrative'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ action, neighborhoodName }),
        signal: controller.signal,
      }).catch(() => null);

      clearTimeout(timer);

      if (res && res.ok) {
        const data = (await res.json()) as { quote?: string };
        if (data.quote) {
          this.cache.set(cacheKey, {
            quote: data.quote,
            expiresAt: Date.now() + 15 * 60 * 1000,
          });
          return data.quote;
        }
      }
    } catch {
      // Bỏ qua lỗi kết nối mạng
    }

    // Luôn có fallback nội bộ lập tức
    const fallback = FallbackLore.getRandomQuote();
    this.cache.set(cacheKey, {
      quote: fallback,
      expiresAt: Date.now() + 5 * 60 * 1000,
    });
    return fallback;
  }
}
